import { ChangeEventHandler } from 'react';

import styles from './textarea.module.css';
interface TextareaProps {
    label: string;
    disabled?: boolean;
    value: string;
    placeholder?: string;
    customStyles?: React.CSSProperties;
    onChange: ChangeEventHandler<HTMLTextAreaElement>;
}
export const Textarea = ({ label, disabled, value, placeholder, customStyles, onChange }: TextareaProps
) => {
    return (
        <div className={styles.textarea} style={customStyles}>
            <label>{label}</label>
            <textarea
                disabled={disabled}
                value={value}
                placeholder={placeholder}
                onChange={onChange}
                rows={4}
            />
        </div>
    )
}